/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import { __decorate, __param, __metadata } from 'tslib';
import { Directive, Optional, TemplateRef, EventEmitter, isDevMode, Input, Output, HostBinding, ContentChild, ViewChild, ElementRef, Component, NgZone, forwardRef, HostListener, ViewChildren, QueryList, Renderer2, NgModule } from '@angular/core';
import { LocalizationService, L10N_PREFIX, ComponentMessages } from '@progress/kendo-angular-l10n';
import { validatePackage } from '@progress/kendo-licensing';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { CommonModule } from '@angular/common';
import { ResizeSensorModule } from '@progress/kendo-angular-common';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IntlService } from '@progress/kendo-angular-intl';

/**
 * Defines a template that will be used for displaying message attachments. To define an attachment
 * template, nest an `<ng-template>` tag with the `kendoChatAttachmentTemplate` attribute inside the
 * `<kendo-chat>` component. The template context is set to the attachment instance. For more information,
 * refer to the article on [message attachments]({% slug attachments_chat %}).
 *
 * {% meta height:700 %}
 * {% embed_file attachments/templates/app.component.ts preview %}
 * {% embed_file shared/app.module.ts preview %}
 * {% embed_file shared/main.ts hidden %}
 * {% endmeta %}
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@progress/kendo-angular-l10n';
import * as ɵngcc2 from '@progress/kendo-angular-buttons';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@progress/kendo-angular-intl';
import * as ɵngcc5 from '@progress/kendo-angular-common';

const _c0 = ["messageInput"];
const _c1 = ["messageList"];
function AttachmentComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AttachmentComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, AttachmentComponent_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template.templateRef)("ngTemplateOutletContext", ctx_r0.context);
} }
function AttachmentComponent_div_1_h5_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h5", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.attachment.title, " ");
} }
function AttachmentComponent_div_1_h6_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h6", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.attachment.subtitle, " ");
} }
function AttachmentComponent_div_1_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img");
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("src", ctx_r5.attachment.content, ɵngcc0.ɵɵsanitizeUrl);
} }
function AttachmentComponent_div_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.attachment.content, " ");
} }
function AttachmentComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    ɵngcc0.ɵɵtemplate(2, AttachmentComponent_div_1_h5_2_Template, 2, 1, "h5", 5);
    ɵngcc0.ɵɵtemplate(3, AttachmentComponent_div_1_h6_3_Template, 2, 1, "h6", 6);
    ɵngcc0.ɵɵtemplate(4, AttachmentComponent_div_1_img_4_Template, 1, 1, "img", 0);
    ɵngcc0.ɵɵtemplate(5, AttachmentComponent_div_1_ng_container_5_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.attachment.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.attachment.subtitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.image);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.unknown);
} }
function HeroCardComponent_img_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.imageUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function HeroCardComponent_h5_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h5", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
} }
function HeroCardComponent_h6_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h6", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.subtitle, " ");
} }
function HeroCardComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 9)(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function HeroCardComponent_span_5_Template_button_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const act_r4 = restoredCtx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.onClick(act_r4)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const act_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", act_r4.title, " ");
} }
const _c6 = ["deck"];
const _c7 = ["item"];
function MessageAttachmentsComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function MessageAttachmentsComponent_button_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.scrollTo(-1)); });
    ɵngcc0.ɵɵelement(1, "span", 4);
    ɵngcc0.ɵɵelementEnd();
} }
function MessageAttachmentsComponent_kendo_chat_attachment_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-chat-attachment", 5, 6);
    ɵngcc0.ɵɵlistener("click", function MessageAttachmentsComponent_kendo_chat_attachment_3_Template_kendo_chat_attachment_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const index_r7 = restoredCtx.index; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r11.itemClick(index_r7)); })("keydown", function MessageAttachmentsComponent_kendo_chat_attachment_3_Template_kendo_chat_attachment_keydown_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const att_r6 = restoredCtx.$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r13.itemKeydown($event, att_r6)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const att_r6 = ctx.$implicit;
    const index_r7 = ctx.index;
    const first_r8 = ctx.first;
    const last_r9 = ctx.last;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("k-state-selected", ctx_r2.isSelected(index_r7))("k-state-focused", ctx_r2.isSelected(index_r7))("k-card-wrap", true)("k-first", first_r8)("k-last", last_r9);
    ɵngcc0.ɵɵproperty("attachment", att_r6)("template", ctx_r2.template);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r2.tabbable && ctx_r2.isSelected(index_r7) ? "0" : "-1");
} }
function MessageAttachmentsComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function MessageAttachmentsComponent_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r14.scrollTo(1)); });
    ɵngcc0.ɵɵelement(1, "span", 7);
    ɵngcc0.ɵɵelementEnd();
} }
function MessageComponent_time_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "time", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-hidden", !ctx_r0.selected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.formatTimeStamp(ctx_r0.message.timestamp), " ");
} }
function MessageComponent_ng_container_1_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c8 = function (a0) { return { $implicit: a0 }; };
function MessageComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, MessageComponent_ng_container_1_div_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.template.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c8, ctx_r5.message));
} }
function MessageComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.message.text, " ");
} }
function MessageComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MessageComponent_ng_container_1_div_1_Template, 2, 4, "div", 5);
    ɵngcc0.ɵɵtemplate(2, MessageComponent_ng_container_1_div_2_Template, 2, 1, "div", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.template);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.template && ctx_r1.message.text);
} }
function MessageComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.message.status, " ");
} }
function MessageComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6)(1, "div", 9);
    ɵngcc0.ɵɵelement(2, "span")(3, "span")(4, "span");
    ɵngcc0.ɵɵelementEnd()();
} }
function MessageListComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.formatTimeStamp(group_r1.timestamp), " ");
} }
function MessageListComponent_ng_container_0_div_3_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 12);
} if (rf & 2) {
    const group_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵattribute("src", group_r1.author.avatarUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function MessageListComponent_ng_container_0_div_3_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(group_r1.author.name);
} }
function MessageListComponent_ng_container_0_div_3_ng_container_3_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 18);
} if (rf & 2) {
    const msg_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("src", msg_r13.user == null ? null : msg_r13.user.avatarUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function MessageListComponent_ng_container_0_div_3_ng_container_3_kendo_chat_attachment_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-chat-attachment", 19);
} if (rf & 2) {
    const msg_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("attachment", msg_r13.attachments[0])("template", ctx_r18.attachmentTemplate);
} }
function MessageListComponent_ng_container_0_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MessageListComponent_ng_container_0_div_3_ng_container_3_img_1_Template, 1, 1, "img", 14);
    ɵngcc0.ɵɵelementStart(2, "kendo-chat-message", 15, 16);
    ɵngcc0.ɵɵlistener("click", function MessageListComponent_ng_container_0_div_3_ng_container_3_Template_kendo_chat_message_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const _r17 = ɵngcc0.ɵɵreference(3); const ctx_r21 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r21.select(_r17)); })("focus", function MessageListComponent_ng_container_0_div_3_ng_container_3_Template_kendo_chat_message_focus_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const _r17 = ɵngcc0.ɵɵreference(3); const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r23.select(_r17)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, MessageListComponent_ng_container_0_div_3_ng_container_3_kendo_chat_attachment_4_Template, 1, 2, "kendo-chat-attachment", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const msg_r13 = ctx.$implicit;
    const firstMessage_r14 = ctx.first;
    const lastMessage_r15 = ctx.last;
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    const group_r1 = ctx_r24.$implicit;
    const lastGroup_r2 = ctx_r24.last;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", msg_r13.user == null ? null : msg_r13.user.avatarUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("k-only", group_r1.messages.length === 1)("k-first", group_r1.messages.length > 1 && firstMessage_r14)("k-last", group_r1.messages.length > 1 && lastMessage_r15);
    ɵngcc0.ɵɵproperty("message", msg_r13)("tabbable", lastGroup_r2 && lastMessage_r15)("template", ctx_r10.messageTemplate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", msg_r13.attachments && msg_r13.attachments.length === 1);
} }
function MessageListComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, MessageListComponent_ng_container_0_div_3_img_1_Template, 1, 1, "img", 9);
    ɵngcc0.ɵɵtemplate(2, MessageListComponent_ng_container_0_div_3_p_2_Template, 2, 1, "p", 10);
    ɵngcc0.ɵɵtemplate(3, MessageListComponent_ng_container_0_div_3_ng_container_3_Template, 5, 11, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("k-alt", ctx_r4.isOwnMessage(group_r1.messages[0]))("k-no-avatar", !group_r1.author.avatarUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", group_r1.author.avatarUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", group_r1.author.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r1.messages);
} }
function MessageListComponent_ng_container_0_kendo_chat_message_attachments_4_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-chat-message-attachments", 20, 21);
    ɵngcc0.ɵɵlistener("click", function MessageListComponent_ng_container_0_kendo_chat_message_attachments_4_Template_kendo_chat_message_attachments_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const _r26 = ɵngcc0.ɵɵreference(1); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r27.select(_r26)); })("focus", function MessageListComponent_ng_container_0_kendo_chat_message_attachments_4_Template_kendo_chat_message_attachments_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const _r26 = ɵngcc0.ɵɵreference(1); const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r29.select(_r26)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext();
    const group_r1 = ctx_r30.$implicit;
    const lastGroup_r2 = ctx_r30.last;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("attachments", group_r1.attachments)("layout", group_r1.attachmentLayout)("tabbable", lastGroup_r2)("template", ctx_r5.attachmentTemplate);
} }
function MessageListComponent_ng_container_0_kendo_chat_suggested_actions_5_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-chat-suggested-actions", 22, 23);
    ɵngcc0.ɵɵlistener("dispatch", function MessageListComponent_ng_container_0_kendo_chat_suggested_actions_5_Template_kendo_chat_suggested_actions_dispatch_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); const group_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r32.dispatchAction($event, ctx_r32.last(group_r1.messages))); })("click", function MessageListComponent_ng_container_0_kendo_chat_suggested_actions_5_Template_kendo_chat_suggested_actions_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r34); const _r31 = ɵngcc0.ɵɵreference(1); const ctx_r35 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r35.select(_r31)); })("focus", function MessageListComponent_ng_container_0_kendo_chat_suggested_actions_5_Template_kendo_chat_suggested_actions_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r34); const _r31 = ɵngcc0.ɵɵreference(1); const ctx_r36 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r36.select(_r31)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = ɵngcc0.ɵɵnextContext();
    const group_r1 = ctx_r37.$implicit;
    const lastGroup_r2 = ctx_r37.last;
    ɵngcc0.ɵɵproperty("actions", group_r1.actions)("tabbable", lastGroup_r2);
} }
function MessageListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0)(1, 2);
    ɵngcc0.ɵɵtemplate(2, MessageListComponent_ng_container_0_div_2_Template, 2, 1, "div", 3);
    ɵngcc0.ɵɵtemplate(3, MessageListComponent_ng_container_0_div_3_Template, 4, 7, "div", 4);
    ɵngcc0.ɵɵtemplate(4, MessageListComponent_ng_container_0_kendo_chat_message_attachments_4_Template, 2, 4, "kendo-chat-message-attachments", 5);
    ɵngcc0.ɵɵtemplate(5, MessageListComponent_ng_container_0_kendo_chat_suggested_actions_5_Template, 2, 2, "kendo-chat-suggested-actions", 6);
    ɵngcc0.ɵɵelementContainerEnd()();
} if (rf & 2) {
    const group_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", group_r1.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "date-marker");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "message-group");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "attachment-group");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "action-group");
} }
function SuggestedActionsComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 1, 2);
    ɵngcc0.ɵɵlistener("click", function SuggestedActionsComponent_span_0_Template_span_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const action_r1 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.actionClick(action_r1)); })("keydown", function SuggestedActionsComponent_span_0_Template_span_keydown_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const action_r1 = restoredCtx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.actionKeydown($event, action_r1)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r1 = ctx.$implicit;
    const index_r2 = ctx.index;
    const first_r3 = ctx.first;
    const last_r4 = ctx.last;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("k-state-selected", ctx_r0.isSelected(index_r2))("k-state-focused", ctx_r0.isSelected(index_r2))("k-first", first_r3)("k-last", last_r4);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r0.tabbable && ctx_r0.selectedIndex === index_r2 ? "0" : "-1");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", action_r1.title || action_r1.value, " ");
} }
let AttachmentTemplateDirective = class AttachmentTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
};
AttachmentTemplateDirective.ɵfac = function AttachmentTemplateDirective_Factory(t) { return new (t || AttachmentTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
AttachmentTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AttachmentTemplateDirective, selectors: [["", "kendoChatAttachmentTemplate", ""]] });
AttachmentTemplateDirective = __decorate([ __param(0, Optional()),
    __metadata("design:paramtypes", [TemplateRef])
], AttachmentTemplateDirective);

/**
 * Arguments for the `SendMessage` event.
 *
 */
class SendMessageEvent {
    /**
     * @hidden
     */
    constructor(message) {
        this.message = message;
    }
}

const noop = () => { };
const ɵ1 = (action, sender) => {
    sender.sendMessage.emit(new SendMessageEvent({
        author: sender.user,
        text: action.value,
        timestamp: new Date()
    }));
}, ɵ2 = (action) => {
    window.open('tel:' + action.value);
}, ɵ3 = (action) => {
    window.open(action.value);
};
const handlers = {
    'reply': ɵ1,
    'call': ɵ2,
    'openUrl': ɵ3
};
/**
 * @hidden
 */
const makeHandler = (action) => handlers[action.type] || noop;

/**
 * Defines a template that will be used for displaying Chat messages. To define an attachment
 * template, nest an `<ng-template>` tag with the `kendoChatMessageTemplate` attribute inside the
 * `<kendo-chat>` component. The template context is set to the message instance. For more information,
 * refer to the article on [message templates]({% slug message_templates_chat %}).
 *
 * {% meta height:700 %}
 * {% embed_file messages/templates/app.component.ts preview %}
 * {% embed_file shared/app.module.ts preview %}
 * {% embed_file shared/main.ts hidden %}
 * {% endmeta %}
 */
let MessageTemplateDirective = class MessageTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
};
MessageTemplateDirective.ɵfac = function MessageTemplateDirective_Factory(t) { return new (t || MessageTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
MessageTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MessageTemplateDirective, selectors: [["", "kendoChatMessageTemplate", ""]] });
MessageTemplateDirective = __decorate([ __param(0, Optional()),
    __metadata("design:paramtypes", [TemplateRef])
], MessageTemplateDirective);

/**
 * @hidden
 */
const packageMetadata = {
    name: '@progress/kendo-angular-conversational-ui',
    productName: 'Kendo UI for Angular',
    productCodes: ['KENDOUIANGULAR', 'KENDOUICOMPLETE'],
    publishDate: 1635940544,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-angular-ui/my-license/?utm_medium=product&utm_source=kendoangular&utm_campaign=kendo-ui-angular-purchase-license-keys-warning'
};

// tslint:disable-next-line:max-line-length
const sendIcon = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16"><path d="M0,14.3c-0.1,0.6,0.3,0.8,0.8,0.6l14.8-6.5c0.5-0.2,0.5-0.6,0-0.8L0.8,1.1C0.3,0.9-0.1,1.1,0,1.7l0.7,4.2C0.8,6.5,1.4,7,1.9,7.1l8.8,0.8c0.6,0.1,0.6,0.1,0,0.2L1.9,8.9C1.4,9,0.8,9.5,0.7,10.1L0,14.3z"/></svg>';
/**
 * Represents the Kendo UI Chat component for Angular.
 *
 * {% meta height:700 %}
 * {% embed_file echo/app.component.ts preview %}
 * {% embed_file shared/app.module.ts %}
 * {% embed_file shared/main.ts hidden %}
 * {% endmeta %}
 *
 */
let ChatComponent = class ChatComponent {
    constructor(localization, zone) {
        this.localization = localization;
        this.zone = zone;
        /**
         * Fires when the user types a message and clicks the **Send** button or presses **Enter**.
         * Emits the [`SendMessageEvent`]({% slug api_conversational-ui_sendmessageevent %}).
         *
         * > The message is not automatically appended to the `messages` array.
         */
        this.sendMessage = new EventEmitter();
        /**
         * Fires when the user clicks a quick action button.
         * The Chat internally handles the `reply`, `openUrl`, and `call` [known actions]({% slug api_conversational-ui_actiontype %}).
         *
         * Emits the [`ExecuteActionEvent`]({% slug api_conversational-ui_executeactionevent %}).
         * The event is preventable. If `preventDefault` is called, the built-in action will be suppressed.
         */
        this.executeAction = new EventEmitter();
        /**
         * @hidden
         */
        this.autoScroll = true;
        validatePackage(packageMetadata);
        this.direction = localization.rtl ? 'rtl' : 'ltr';
        this.localizationChangeSubscription = localization.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        });
    }
    get className() {
        return 'k-widget k-chat';
    }
    get dirAttr() {
        return this.direction;
    }
    ngOnChanges() {
        this.zone.runOutsideAngular(() => setTimeout(() => {
            this.messageList.nativeElement.style.flex = '1 1 auto';
        }));
    }
    ngAfterViewInit() {
        if (!isDevMode()) {
            return;
        }
        if (!this.user) {
            throw new Error('User must be set and have a valid id.');
        }
    }
    ngOnDestroy() {
        if (this.localizationChangeSubscription) {
            this.localizationChangeSubscription.unsubscribe();
        }
    }
    /**
     * @hidden
     */
    sendClick() {
        const input = this.messageInput.nativeElement;
        const value = input.value;
        if (!value) {
            return;
        }
        const message = {
            author: this.user,
            text: value,
            timestamp: new Date()
        };
        this.sendMessage.emit(new SendMessageEvent(message));
        input.value = null;
        input.focus();
        this.autoScroll = true;
    }
    /**
     * @hidden
     */
    inputKeydown(e) {
        if (e.keyCode === 13 /* enter */) {
            this.sendClick();
        }
    }
    /**
     * @hidden
     */
    dispatchAction(e) {
        this.executeAction.emit(e);
        if (!e.isDefaultPrevented()) {
            const handler = makeHandler(e.action);
            handler(e.action, this);
            this.messageInput.nativeElement.focus();
        }
    }
    /**
     * @hidden
     */
    textFor(key) {
        return this.localization.get(key);
    }
};
ChatComponent.ɵfac = function ChatComponent_Factory(t) { return new (t || ChatComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
ChatComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ChatComponent, selectors: [["kendo-chat"]], contentQueries: function ChatComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, AttachmentTemplateDirective, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MessageTemplateDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.attachmentTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.messageTemplate = _t.first);
    } }, viewQuery: function ChatComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.messageInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.messageList = _t.first);
    } }, hostVars: 3, hostBindings: function ChatComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.dirAttr);
        ɵngcc0.ɵɵclassMap(ctx.className);
    } }, inputs: { messages: "messages", user: "user" }, outputs: { sendMessage: "sendMessage", executeAction: "executeAction" }, features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.chat'
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 7, consts: function () { let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The placholder text of the message text input
         * @meaning kendo.chat.messagePlaceholder
         */
        const MSG_EXTERNAL_7460803912395701353$$DIST_FESM2015_INDEX_JS_3 = goog.getMsg("Type a message...");
        i18n_2 = MSG_EXTERNAL_7460803912395701353$$DIST_FESM2015_INDEX_JS_3;
    }
    else {
        i18n_2 = $localize `:kendo.chat.messagePlaceholder|The placholder text of the message text input␟a4e7da5ddd2f2db3f0b322b0a162a524dfe6cb81␟7460803912395701353:Type a message...`;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text for the Send button
         * @meaning kendo.chat.send
         */
        const MSG_EXTERNAL_4984081606393486044$$DIST_FESM2015_INDEX_JS_5 = goog.getMsg("Send...");
        i18n_4 = MSG_EXTERNAL_4984081606393486044$$DIST_FESM2015_INDEX_JS_5;
    }
    else {
        i18n_4 = $localize `:kendo.chat.send|The text for the Send button␟94410f5d089bd36108a60e3b1b04d47f8ea1b94a␟4984081606393486044:Send...`;
    } return [["kendoChatLocalizedMessages", "", "messagePlaceholder", i18n_2, "send", i18n_4], ["aria-live", "polite", "role", "log", "kendoChatScrollAnchor", "", 1, "k-message-list", "k-avatars", 3, "autoScroll", "autoScrollChange"], ["messageList", "", "anchor", "scrollAnchor"], [3, "messages", "messageTemplate", "attachmentTemplate", "user", "executeAction", "resize", "navigate"], [1, "k-message-box"], ["kendoChatFocusedState", "", "type", "text", 1, "k-input", 3, "placeholder", "keydown"], ["messageInput", ""], ["kendoButton", "", "look", "flat", "tabindex", "-1", 1, "k-button-send", 3, "click"], ["version", "1.1", "xmlns", "http://www.w3.org/2000/svg", "x", "0px", "y", "0px", "viewBox", "0 0 16 16"], ["d", "M0,14.3c-0.1,0.6,0.3,0.8,0.8,0.6l14.8-6.5c0.5-0.2,0.5-0.6,0-0.8L0.8,1.1C0.3,0.9-0.1,1.1,0,1.7l0.7,4.2C0.8,6.5,1.4,7,1.9,7.1l8.8,0.8c0.6,0.1,0.6,0.1,0,0.2L1.9,8.9C1.4,9,0.8,9.5,0.7,10.1L0,14.3z"]]; }, template: function ChatComponent_Template(rf, ctx) { if (rf & 1) {
        const _r3 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementContainer(0, 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
        ɵngcc0.ɵɵlistener("autoScrollChange", function ChatComponent_Template_div_autoScrollChange_1_listener($event) { return ctx.autoScroll = $event; });
        ɵngcc0.ɵɵelementStart(4, "kendo-chat-message-list", 3);
        ɵngcc0.ɵɵlistener("executeAction", function ChatComponent_Template_kendo_chat_message_list_executeAction_4_listener($event) { return ctx.dispatchAction($event); })("resize", function ChatComponent_Template_kendo_chat_message_list_resize_4_listener() { ɵngcc0.ɵɵrestoreView(_r3); const _r1 = ɵngcc0.ɵɵreference(3); return ɵngcc0.ɵɵresetView(_r1.scrollToBottom()); })("navigate", function ChatComponent_Template_kendo_chat_message_list_navigate_4_listener() { return ctx.autoScroll = false; });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 4)(6, "input", 5, 6);
        ɵngcc0.ɵɵlistener("keydown", function ChatComponent_Template_input_keydown_6_listener($event) { return ctx.inputKeydown($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "button", 7);
        ɵngcc0.ɵɵlistener("click", function ChatComponent_Template_button_click_8_listener() { return ctx.sendClick(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(9, "svg", 8);
        ɵngcc0.ɵɵelement(10, "path", 9);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("autoScroll", ctx.autoScroll);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("messages", ctx.messages)("messageTemplate", ctx.messageTemplate)("attachmentTemplate", ctx.attachmentTemplate)("user", ctx.user);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ctx.textFor("messagePlaceholder"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("title", ctx.textFor("send"));
    } }, dependencies: function () { return [ɵngcc2.ButtonDirective, FocusedStateDirective, LocalizedMessagesDirective, MessageListComponent, ScrollAnchorDirective]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], ChatComponent.prototype, "messages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ChatComponent.prototype, "user", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ChatComponent.prototype, "sendMessage", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ChatComponent.prototype, "executeAction", void 0);
__decorate([
    HostBinding('class'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], ChatComponent.prototype, "className", null);
__decorate([
    HostBinding('attr.dir'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], ChatComponent.prototype, "dirAttr", null);
__decorate([
    ContentChild(AttachmentTemplateDirective, { static: false }),
    __metadata("design:type", AttachmentTemplateDirective)
], ChatComponent.prototype, "attachmentTemplate", void 0);
__decorate([
    ContentChild(MessageTemplateDirective, { static: false }),
    __metadata("design:type", MessageTemplateDirective)
], ChatComponent.prototype, "messageTemplate", void 0);
__decorate([
    ViewChild('messageInput', { static: true }),
    __metadata("design:type", ElementRef)
], ChatComponent.prototype, "messageInput", void 0);
__decorate([
    ViewChild('messageList', { static: true }),
    __metadata("design:type", ElementRef)
], ChatComponent.prototype, "messageList", void 0);
ChatComponent = __decorate([ __metadata("design:paramtypes", [LocalizationService,
        NgZone])
], ChatComponent);

/**
 * @hidden
 */
let AttachmentComponent = class AttachmentComponent {
    set attachment(value) {
        this._attachment = value;
        this.context = {
            $implicit: this.attachment
        };
    }
    get attachment() {
        return this._attachment;
    }
    get image() {
        return this.contentType.indexOf('image/') === 0;
    }
    get unknown() {
        return !this.image;
    }
    get contentType() {
        return this.attachment.contentType || '';
    }
};
AttachmentComponent.ɵfac = function AttachmentComponent_Factory(t) { return new (t || AttachmentComponent)(); };
AttachmentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AttachmentComponent, selectors: [["kendo-chat-attachment"]], inputs: { attachment: "attachment", template: "template" }, decls: 2, vars: 2, consts: [[4, "ngIf"], ["class", "k-card", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "k-card"], [1, "k-card-body"], ["class", "k-card-title", 4, "ngIf"], ["class", "k-card-subtitle", 4, "ngIf"], [1, "k-card-title"], [1, "k-card-subtitle"]], template: function AttachmentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AttachmentComponent_ng_container_0_Template, 2, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, AttachmentComponent_div_1_Template, 6, 4, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.template);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.template);
    } }, dependencies: [ɵngcc3.NgIf, ɵngcc3.NgTemplateOutlet], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], AttachmentComponent.prototype, "attachment", null);
__decorate([
    Input(),
    __metadata("design:type", AttachmentTemplateDirective)
], AttachmentComponent.prototype, "template", void 0);

/**
 * @hidden
 */
class Messages extends ComponentMessages {
}
Messages.ɵfac = /*@__PURE__*/ function () { let ɵMessages_BaseFactory; return function Messages_Factory(t) { return (ɵMessages_BaseFactory || (ɵMessages_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(Messages)))(t || Messages); }; }();
Messages.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: Messages, inputs: { messagePlaceholder: "messagePlaceholder", send: "send" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "messagePlaceholder", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "send", void 0);

var CustomMessagesComponent_1;
// tslint:disable:no-forward-ref
/**
 * Custom component messages override default component messages
 * ([see example]({% slug globalization_chat %}#toc-custom-messages)).
 */
let CustomMessagesComponent = CustomMessagesComponent_1 = class CustomMessagesComponent extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
};
CustomMessagesComponent.ɵfac = function CustomMessagesComponent_Factory(t) { return new (t || CustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
CustomMessagesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CustomMessagesComponent, selectors: [["kendo-chat-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => CustomMessagesComponent_1)
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function CustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
CustomMessagesComponent = CustomMessagesComponent_1 = __decorate([ __metadata("design:paramtypes", [LocalizationService])
], CustomMessagesComponent);

/**
 * @hidden
 */
let FocusedStateDirective = class FocusedStateDirective {
    /**
     * @hidden
     */
    constructor() {
        this.focused = false;
    }
    onFocus() {
        this.focused = true;
    }
    onBlur() {
        this.focused = false;
    }
};
FocusedStateDirective.ɵfac = function FocusedStateDirective_Factory(t) { return new (t || FocusedStateDirective)(); };
FocusedStateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FocusedStateDirective, selectors: [["", "kendoChatFocusedState", ""]], hostVars: 2, hostBindings: function FocusedStateDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function FocusedStateDirective_focusin_HostBindingHandler() { return ctx.onFocus(); })("focusout", function FocusedStateDirective_focusout_HostBindingHandler() { return ctx.onBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-state-focused", ctx.focused);
    } } });
__decorate([
    HostBinding('class.k-state-focused'),
    __metadata("design:type", Boolean)
], FocusedStateDirective.prototype, "focused", void 0);
__decorate([
    HostListener('focusin'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FocusedStateDirective.prototype, "onFocus", null);
__decorate([
    HostListener('focusout'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FocusedStateDirective.prototype, "onBlur", null);

/**
 * Represents a Hero Card component ([see example]({% slug dialogflow_chat %})).
 * Hero cards host a single large image and action buttons with text content.
 */
let HeroCardComponent = class HeroCardComponent {
    /**
     * Represents a Hero Card component ([see example]({% slug dialogflow_chat %})).
     * Hero cards host a single large image and action buttons with text content.
     */
    constructor() {
        this.cssClass = true;
        /**
         * Fires when the user clicks a button.
         */
        this.executeAction = new EventEmitter();
    }
    onClick(action) {
        this.executeAction.next(action);
    }
};
HeroCardComponent.ɵfac = function HeroCardComponent_Factory(t) { return new (t || HeroCardComponent)(); };
HeroCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeroCardComponent, selectors: [["kendo-chat-hero-card"]], hostVars: 2, hostBindings: function HeroCardComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-card", ctx.cssClass);
    } }, inputs: { imageUrl: "imageUrl", title: "title", subtitle: "subtitle", actions: "actions" }, outputs: { executeAction: "executeAction" }, decls: 6, vars: 4, consts: [["class", "k-card-image", 3, "src", 4, "ngIf"], [1, "k-card-body"], ["class", "k-card-title", 4, "ngIf"], ["class", "k-card-subtitle", 4, "ngIf"], [1, "k-card-actions", "k-card-actions-vertical"], ["class", "k-card-action", 4, "ngFor", "ngForOf"], [1, "k-card-image", 3, "src"], [1, "k-card-title"], [1, "k-card-subtitle"], [1, "k-card-action"], ["kendoButton", "", "look", "flat", 3, "click"]], template: function HeroCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HeroCardComponent_img_0_Template, 1, 1, "img", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, HeroCardComponent_h5_2_Template, 2, 1, "h5", 2);
        ɵngcc0.ɵɵtemplate(3, HeroCardComponent_h6_3_Template, 2, 1, "h6", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, HeroCardComponent_span_5_Template, 3, 1, "span", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.subtitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.actions);
    } }, dependencies: [ɵngcc2.ButtonDirective, ɵngcc3.NgForOf, ɵngcc3.NgIf], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", String)
], HeroCardComponent.prototype, "imageUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], HeroCardComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], HeroCardComponent.prototype, "subtitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], HeroCardComponent.prototype, "actions", void 0);
__decorate([
    HostBinding('class.k-card'),
    __metadata("design:type", Boolean)
], HeroCardComponent.prototype, "cssClass", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], HeroCardComponent.prototype, "executeAction", void 0);

var LocalizedMessagesDirective_1;
// tslint:disable:no-forward-ref
/**
 * @hidden
 */
let LocalizedMessagesDirective = LocalizedMessagesDirective_1 = class LocalizedMessagesDirective extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
};
LocalizedMessagesDirective.ɵfac = function LocalizedMessagesDirective_Factory(t) { return new (t || LocalizedMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
LocalizedMessagesDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LocalizedMessagesDirective, selectors: [["", "kendoChatLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => LocalizedMessagesDirective_1)
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
LocalizedMessagesDirective = LocalizedMessagesDirective_1 = __decorate([ __metadata("design:paramtypes", [LocalizationService])
], LocalizedMessagesDirective);

/**
 * @hidden
 */
class ChatItem {
}
ChatItem.ɵfac = function ChatItem_Factory(t) { return new (t || ChatItem)(); };
ChatItem.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ChatItem });

var MessageAttachmentsComponent_1;
// tslint:disable:no-forward-ref
/**
 * @hidden
 */
let MessageAttachmentsComponent = MessageAttachmentsComponent_1 = class MessageAttachmentsComponent extends ChatItem {
    constructor(zone) {
        super();
        this.zone = zone;
        this.scrollPosition = 0;
        this.selectedIndex = 0;
        this.carouselKeyHandlers = {
            [37 /* left */]: (e) => this.navigateTo(e, -1),
            [39 /* right */]: (e) => this.navigateTo(e, 1)
        };
        this.listKeyHandlers = {
            [38 /* up */]: (e) => this.navigateTo(e, -1),
            [40 /* down */]: (e) => this.navigateTo(e, 1)
        };
    }
    get carousel() {
        return this.layout !== 'list';
    }
    ngAfterViewInit() {
        this.zone.runOutsideAngular(() => {
            const scrollDebounceTime = 100;
            this.scrollSubscription = fromEvent(this.deck.nativeElement, 'scroll')
                .pipe(debounceTime(scrollDebounceTime))
                .subscribe(() => this.onScroll());
        });
    }
    ngOnDestroy() {
        this.scrollSubscription.unsubscribe();
    }
    isSelected(index) {
        return this.selectedIndex === index;
    }
    itemKeydown(e, attachment) {
        const keyHandlers = this.layout === 'list' ?
            this.listKeyHandlers : this.carouselKeyHandlers;
        const handler = keyHandlers[e.keyCode];
        if (handler) {
            handler(e, attachment);
        }
    }
    itemClick(index) {
        this.select(index);
    }
    focus() {
        this.select(this.selectedIndex);
    }
    scrollTo(dir) {
        const el = this.deck.nativeElement;
        const scrollStep = el.scrollWidth / this.items.length;
        const max = el.scrollWidth - el.offsetWidth;
        const pos = el.scrollLeft + scrollStep * dir;
        el.scrollLeft = Math.max(0, Math.min(max, pos));
    }
    select(index) {
        this.selectedIndex = index;
        const item = this.items.toArray()[index];
        if (item) {
            item.nativeElement.focus();
        }
    }
    navigateTo(e, offset) {
        const prevIndex = this.selectedIndex;
        const nextIndex = Math.max(0, Math.min(prevIndex + offset, this.items.length - 1));
        if (nextIndex !== prevIndex) {
            this.select(nextIndex);
            e.preventDefault();
        }
    }
    onScroll() {
        const el = this.deck.nativeElement;
        if (el.scrollWidth === 0) {
            return;
        }
        const pos = el.scrollLeft / (el.scrollWidth - el.offsetWidth);
        if (pos !== this.scrollPosition) {
            this.zone.run(() => {
                this.scrollPosition = pos;
            });
        }
    }
};
MessageAttachmentsComponent.ɵfac = function MessageAttachmentsComponent_Factory(t) { return new (t || MessageAttachmentsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
MessageAttachmentsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MessageAttachmentsComponent, selectors: [["kendo-chat-message-attachments"]], viewQuery: function MessageAttachmentsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 7, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c7, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.deck = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, hostVars: 2, hostBindings: function MessageAttachmentsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-card-deck-scrollwrap", ctx.carousel);
    } }, inputs: { attachments: "attachments", layout: "layout", tabbable: "tabbable", template: "template" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: ChatItem,
                useExisting: forwardRef(() => MessageAttachmentsComponent_1)
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 5, consts: [["class", "k-button k-button-icon", "tabindex", "-1", 3, "click", 4, "ngIf"], ["deck", ""], [3, "attachment", "template", "k-state-selected", "k-state-focused", "k-card-wrap", "k-first", "k-last", "click", "keydown", 4, "ngFor", "ngForOf"], ["tabindex", "-1", 1, "k-button", "k-button-icon", 3, "click"], [1, "k-icon", "k-i-arrow-chevron-left"], [3, "attachment", "template", "click", "keydown"], ["item", ""], [1, "k-icon", "k-i-arrow-chevron-right"]], template: function MessageAttachmentsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MessageAttachmentsComponent_button_0_Template, 2, 0, "button", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵtemplate(3, MessageAttachmentsComponent_kendo_chat_attachment_3_Template, 2, 13, "kendo-chat-attachment", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, MessageAttachmentsComponent_button_4_Template, 2, 0, "button", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.carousel && ctx.scrollPosition > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("k-card-deck", ctx.carousel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.attachments);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.carousel && ctx.scrollPosition < 1);
    } }, dependencies: [ɵngcc3.NgForOf, ɵngcc3.NgIf, AttachmentComponent], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], MessageAttachmentsComponent.prototype, "attachments", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], MessageAttachmentsComponent.prototype, "layout", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], MessageAttachmentsComponent.prototype, "tabbable", void 0);
__decorate([
    Input(),
    __metadata("design:type", AttachmentTemplateDirective)
], MessageAttachmentsComponent.prototype, "template", void 0);
__decorate([
    HostBinding('class.k-card-deck-scrollwrap'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], MessageAttachmentsComponent.prototype, "carousel", null);
__decorate([
    ViewChild('deck', { read: ElementRef, static: true }),
    __metadata("design:type", ElementRef)
], MessageAttachmentsComponent.prototype, "deck", void 0);
__decorate([
    ViewChildren('item', { read: ElementRef }),
    __metadata("design:type", QueryList)
], MessageAttachmentsComponent.prototype, "items", void 0);
MessageAttachmentsComponent = MessageAttachmentsComponent_1 = __decorate([ __metadata("design:paramtypes", [NgZone])
], MessageAttachmentsComponent);

var MessageComponent_1;
// tslint:disable:no-forward-ref
/**
 * @hidden
 */
let MessageComponent = MessageComponent_1 = class MessageComponent extends ChatItem {
    constructor(element, intl) {
        super();
        this.element = element;
        this.intl = intl;
        this.cssClass = true;
    }
    get tabIndex() {
        return this.tabbable ? '0' : '-1';
    }
    formatTimeStamp(date) {
        return this.intl.formatDate(date, { datetime: 'short' });
    }
    focus() {
        this.element.nativeElement.focus();
    }
};
MessageComponent.ɵfac = function MessageComponent_Factory(t) { return new (t || MessageComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.IntlService)); };
MessageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MessageComponent, selectors: [["kendo-chat-message"]], hostVars: 7, hostBindings: function MessageComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabIndex", ctx.tabIndex);
        ɵngcc0.ɵɵclassProp("k-message", ctx.cssClass)("k-state-selected", ctx.selected)("k-state-focused", ctx.selected);
    } }, inputs: { message: "message", tabbable: "tabbable", template: "template" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: ChatItem,
                useExisting: forwardRef(() => MessageComponent_1)
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 4, consts: [["class", "k-message-time", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["class", "k-message-status", 4, "ngIf"], ["typing", ""], [1, "k-message-time"], ["class", "k-bubble", 4, "ngIf"], [1, "k-bubble"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "k-message-status"], [1, "k-typing-indicator"]], template: function MessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MessageComponent_time_0_Template, 2, 2, "time", 0);
        ɵngcc0.ɵɵtemplate(1, MessageComponent_ng_container_1_Template, 3, 2, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, MessageComponent_span_2_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵtemplate(3, MessageComponent_ng_template_3_Template, 5, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message.timestamp);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.message.typing)("ngIfElse", _r3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message.status);
    } }, dependencies: [ɵngcc3.NgIf, ɵngcc3.NgTemplateOutlet], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], MessageComponent.prototype, "message", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], MessageComponent.prototype, "tabbable", void 0);
__decorate([
    Input(),
    __metadata("design:type", MessageTemplateDirective)
], MessageComponent.prototype, "template", void 0);
__decorate([
    HostBinding('class.k-message'),
    __metadata("design:type", Boolean)
], MessageComponent.prototype, "cssClass", void 0);
__decorate([
    HostBinding('class.k-state-selected'),
    HostBinding('class.k-state-focused'),
    __metadata("design:type", Boolean)
], MessageComponent.prototype, "selected", void 0);
__decorate([
    HostBinding('attr.tabIndex'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], MessageComponent.prototype, "tabIndex", null);
MessageComponent = MessageComponent_1 = __decorate([ __metadata("design:paramtypes", [ElementRef, IntlService])
], MessageComponent);

/**
 * @hidden
 */
class PreventableEvent {
    constructor() {
        this.prevented = false;
    }
    /**
     * Prevents the default action for a specified event.
     * In this way, the source component suppresses
     * the built-in behavior that follows the event.
     */
    preventDefault() {
        this.prevented = true;
    }
    /**
     * Returns `true` if the event was prevented
     * by any of its subscribers.
     *
     * @returns `true` if the default action was prevented.
     * Otherwise, returns `false`.
     */
    isDefaultPrevented() {
        return this.prevented;
    }
}

/**
 * Arguments for the `executeAction` event. The `executeAction` event fires when the user clicks
 * a quick action button. Calling `preventDefault()` suppresses the built-in action handler.
 */
class ExecuteActionEvent extends PreventableEvent {
    /**
     * @hidden
     */
    constructor(action, message) {
        super();
        this.action = action;
        this.message = message;
    }
}

/**
 * @hidden
 */
const closest = (node, predicate) => {
    while (node && !predicate(node)) {
        node = node.parentNode;
    }
    return node;
};

/**
 * @hidden
 */
const isAuthor = (user, msg) => user && msg.author && user.id === msg.author.id;
const last = (arr) => arr[arr.length - 1];
const dateChanged = (curr, prev) => (curr && prev) && (prev.getDate() !== curr.getDate() ||
    prev.getMonth() !== curr.getMonth() ||
    prev.getFullYear() !== curr.getFullYear());
const addDateMarker = (acc, msg) => {
    const timestamp = msg.timestamp;
    const lastItem = last(acc);
    if (!timestamp) {
        return;
    }
    if (!lastItem || dateChanged(timestamp, lastItem.timestamp)) {
        const dateMarker = {
            type: 'date-marker',
            timestamp: timestamp,
            trackBy: timestamp.getTime()
        };
        acc.push(dateMarker);
    }
};
const groupMessages = (acc, msg, isLastMessage) => {
    const lastItem = last(acc);
    let messages;
    if (isDevMode() && !msg.author) {
        throw new Error('Author must be set for message: ' + JSON.stringify(msg));
    }
    if (msg.typing && !isLastMessage) {
        return;
    }
    if (lastItem && lastItem.type === 'message-group') {
        messages = lastItem.messages;
    }
    if (messages && isAuthor(msg.author, last(messages))) {
        messages.push(msg);
    }
    else {
        acc.push({
            type: 'message-group',
            messages: [msg],
            author: msg.author,
            timestamp: msg.timestamp,
            trackBy: msg
        });
    }
};
const groupItems = (total) => (acc, msg, index) => {
    const isLastMessage = index === total - 1;
    addDateMarker(acc, msg);
    groupMessages(acc, msg, isLastMessage);
    if (msg.attachments && msg.attachments.length > 1) {
        acc.push({
            type: 'attachment-group',
            attachments: msg.attachments,
            attachmentLayout: msg.attachmentLayout,
            timestamp: msg.timestamp,
            trackBy: msg
        });
    }
    if (msg.suggestedActions && isLastMessage) {
        acc.push({
            type: 'action-group',
            actions: msg.suggestedActions,
            timestamp: msg.timestamp,
            trackBy: msg
        });
    }
    return acc;
};
/**
 * @hidden
 */
const chatView = (messages) => messages.reduce(groupItems(messages.length), []);

/**
 * @hidden
 */
let MessageListComponent = class MessageListComponent {
    constructor(element, intl) {
        this.element = element;
        this.intl = intl;
        this.executeAction = new EventEmitter();
        this.navigate = new EventEmitter();
        this.resize = new EventEmitter();
        this.cssClass = true;
        this.view = [];
        this.keyActions = {
            [38 /* up */]: (e) => this.navigateTo(e, -1),
            [40 /* down */]: (e) => this.navigateTo(e, 1)
        };
    }
    set messages(value) {
        const data = value || [];
        this.view = chatView(data);
        this._messages = data;
    }
    get messages() {
        return this._messages;
    }
    ngAfterViewInit() {
        this.selectedItem = this.items.last;
    }
    onResize() {
        this.resize.emit();
    }
    formatTimeStamp(date) {
        return this.intl.formatDate(date, { date: 'full' });
    }
    onKeydown(e) {
        const action = this.keyActions[e.keyCode];
        if (action) {
            action(e);
        }
    }
    onBlur(args) {
        const next = args.relatedTarget || document.activeElement;
        const outside = !closest(next, (node) => node === this.element.nativeElement);
        if (outside) {
            this.select(null);
        }
    }
    isOwnMessage(msg) {
        return isAuthor(this.user, msg);
    }
    dispatchAction(action, message) {
        const args = new ExecuteActionEvent(action, message);
        this.executeAction.emit(args);
    }
    trackGroup(_index, item) {
        return item.trackBy;
    }
    select(item) {
        const prevItem = this.selectedItem;
        if (prevItem) {
            prevItem.selected = false;
        }
        if (item) {
            item.selected = true;
            this.selectedItem = item;
        }
    }
    last(items) {
        if (!items || items.length === 0) {
            return;
        }
        return items[items.length - 1];
    }
    navigateTo(e, offset) {
        const items = this.items.toArray();
        const prevItem = this.selectedItem;
        const prevIndex = items.indexOf(prevItem);
        const nextIndex = Math.max(0, Math.min(prevIndex + offset, this.items.length - 1));
        const nextItem = items[nextIndex];
        if (nextItem !== prevItem) {
            this.select(nextItem);
            nextItem.focus();
            this.navigate.emit();
            e.preventDefault();
        }
    }
};
MessageListComponent.ɵfac = function MessageListComponent_Factory(t) { return new (t || MessageListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.IntlService)); };
MessageListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MessageListComponent, selectors: [["kendo-chat-message-list"]], viewQuery: function MessageListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(ChatItem, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, hostVars: 2, hostBindings: function MessageListComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function MessageListComponent_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); })("focusout", function MessageListComponent_focusout_HostBindingHandler($event) { return ctx.onBlur($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-message-list-content", ctx.cssClass);
    } }, inputs: { messages: "messages", attachmentTemplate: "attachmentTemplate", messageTemplate: "messageTemplate", user: "user" }, outputs: { executeAction: "executeAction", navigate: "navigate", resize: "resize" }, decls: 2, vars: 2, consts: [[4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "resize"], [3, "ngSwitch"], ["class", "k-timestamp", 4, "ngSwitchCase"], ["class", "k-message-group", 3, "k-alt", "k-no-avatar", 4, "ngSwitchCase"], [3, "attachments", "layout", "tabbable", "template", "click", "focus", 4, "ngSwitchCase"], [3, "actions", "tabbable", "dispatch", "click", "focus", 4, "ngSwitchCase"], [1, "k-timestamp"], [1, "k-message-group"], ["class", "k-avatar", 4, "ngIf"], ["class", "k-author", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "k-avatar"], [1, "k-author"], ["class", "k-avatar", 3, "src", 4, "ngIf"], [3, "message", "tabbable", "template", "click", "focus"], ["message", ""], [3, "attachment", "template", 4, "ngIf"], [1, "k-avatar", 3, "src"], [3, "attachment", "template"], [3, "attachments", "layout", "tabbable", "template", "click", "focus"], ["attachments", ""], [3, "actions", "tabbable", "dispatch", "click", "focus"], ["actions", ""]], template: function MessageListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MessageListComponent_ng_container_0_Template, 6, 5, "ng-container", 0);
        ɵngcc0.ɵɵelementStart(1, "kendo-resize-sensor", 1);
        ɵngcc0.ɵɵlistener("resize", function MessageListComponent_Template_kendo_resize_sensor_resize_1_listener() { return ctx.onResize(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.view)("ngForTrackBy", ctx.trackGroup);
    } }, dependencies: function () { return [ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc3.NgSwitch, ɵngcc3.NgSwitchCase, ɵngcc5.ResizeSensorComponent, AttachmentComponent, MessageAttachmentsComponent, MessageComponent, SuggestedActionsComponent]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], MessageListComponent.prototype, "messages", null);
__decorate([
    Input(),
    __metadata("design:type", AttachmentTemplateDirective)
], MessageListComponent.prototype, "attachmentTemplate", void 0);
__decorate([
    Input(),
    __metadata("design:type", MessageTemplateDirective)
], MessageListComponent.prototype, "messageTemplate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], MessageListComponent.prototype, "user", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MessageListComponent.prototype, "executeAction", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MessageListComponent.prototype, "navigate", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MessageListComponent.prototype, "resize", void 0);
__decorate([
    ViewChildren(ChatItem),
    __metadata("design:type", QueryList)
], MessageListComponent.prototype, "items", void 0);
__decorate([
    HostBinding('class.k-message-list-content'),
    __metadata("design:type", Boolean)
], MessageListComponent.prototype, "cssClass", void 0);
__decorate([
    HostListener('keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MessageListComponent.prototype, "onKeydown", null);
__decorate([
    HostListener('focusout', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [FocusEvent]),
    __metadata("design:returntype", void 0)
], MessageListComponent.prototype, "onBlur", null);
MessageListComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, IntlService])
], MessageListComponent);

// Consider scroll to be at the bottom when within this number of pixels from the container height.
const maxDelta = 2;
/**
 * @hidden
 */
let ScrollAnchorDirective = class ScrollAnchorDirective {
    constructor(element, zone, renderer) {
        this.element = element;
        this.zone = zone;
        this.renderer = renderer;
        this.autoScroll = true;
        this.autoScrollChange = new EventEmitter();
        this.overflowAnchor = 'none';
        this.scrolling = false;
    }
    ngOnInit() {
        this.zone.runOutsideAngular(() => {
            this.unsubscribe = this.renderer.listen(this.element.nativeElement, 'scroll', () => this.onScroll());
        });
    }
    ngAfterViewInit() {
        this.scrollToBottom();
    }
    ngOnDestroy() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }
    onScroll() {
        if (this.scrolling) {
            return;
        }
        const el = this.element.nativeElement;
        const bottom = el.scrollTop + el.offsetHeight;
        const height = el.scrollHeight;
        const atBottom = height - bottom < maxDelta;
        if (this.autoScroll !== atBottom) {
            this.zone.run(() => {
                this.autoScroll = atBottom;
                this.autoScrollChange.emit(this.autoScroll);
            });
        }
    }
    scrollToBottom() {
        if (!this.autoScroll) {
            return;
        }
        const el = this.element.nativeElement;
        el.scrollTop = el.scrollHeight - el.clientHeight;
        this.scrolling = true;
        this.zone.runOutsideAngular(() => setTimeout(() => this.scrolling = false, 1000));
    }
};
ScrollAnchorDirective.ɵfac = function ScrollAnchorDirective_Factory(t) { return new (t || ScrollAnchorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ScrollAnchorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ScrollAnchorDirective, selectors: [["", "kendoChatScrollAnchor", ""]], hostVars: 2, hostBindings: function ScrollAnchorDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("overflow-anchor", ctx.overflowAnchor);
    } }, inputs: { autoScroll: "autoScroll" }, outputs: { autoScrollChange: "autoScrollChange" }, exportAs: ["scrollAnchor"] });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ScrollAnchorDirective.prototype, "autoScroll", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ScrollAnchorDirective.prototype, "autoScrollChange", void 0);
__decorate([
    HostBinding('style.overflow-anchor'),
    __metadata("design:type", String)
], ScrollAnchorDirective.prototype, "overflowAnchor", void 0);
ScrollAnchorDirective = __decorate([ __metadata("design:paramtypes", [ElementRef,
        NgZone,
        Renderer2])
], ScrollAnchorDirective);

var SuggestedActionsComponent_1;
// tslint:disable:no-forward-ref
/**
 * @hidden
 */
let SuggestedActionsComponent = SuggestedActionsComponent_1 = class SuggestedActionsComponent extends ChatItem {
    // tslint:disable:no-forward-ref
    /**
     * @hidden
     */
    constructor() {
        super(...arguments);
        this.dispatch = new EventEmitter();
        this.defaultClass = true;
        this.selectedIndex = 0;
        this.keyHandlers = {
            [37 /* left */]: (e) => this.navigateTo(e, -1),
            [39 /* right */]: (e) => this.navigateTo(e, 1),
            [13 /* enter */]: (_, action) => this.actionClick(action)
        };
    }
    isSelected(index) {
        return this.selected && this.selectedIndex === index;
    }
    actionClick(action) {
        this.dispatch.next(action);
    }
    actionKeydown(e, action) {
        const handler = this.keyHandlers[e.keyCode];
        if (handler) {
            handler(e, action);
        }
    }
    focus() {
        this.select(this.selectedIndex);
    }
    select(index) {
        this.selectedIndex = index;
        const item = this.items.toArray()[index];
        if (item) {
            item.nativeElement.focus();
        }
    }
    navigateTo(e, offset) {
        const prevIndex = this.selectedIndex;
        const nextIndex = Math.max(0, Math.min(prevIndex + offset, this.items.length - 1));
        if (nextIndex !== prevIndex) {
            this.select(nextIndex);
            e.preventDefault();
        }
    }
};
SuggestedActionsComponent.ɵfac = /*@__PURE__*/ function () { let ɵSuggestedActionsComponent_BaseFactory; return function SuggestedActionsComponent_Factory(t) { return (ɵSuggestedActionsComponent_BaseFactory || (ɵSuggestedActionsComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(SuggestedActionsComponent)))(t || SuggestedActionsComponent); }; }();
SuggestedActionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SuggestedActionsComponent, selectors: [["kendo-chat-suggested-actions"]], viewQuery: function SuggestedActionsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c7, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, hostVars: 2, hostBindings: function SuggestedActionsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-quick-replies", ctx.defaultClass);
    } }, inputs: { actions: "actions", tabbable: "tabbable" }, outputs: { dispatch: "dispatch" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: ChatItem,
                useExisting: forwardRef(() => SuggestedActionsComponent_1)
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "k-quick-reply", 3, "k-state-selected", "k-state-focused", "k-first", "k-last", "click", "keydown", 4, "ngFor", "ngForOf"], [1, "k-quick-reply", 3, "click", "keydown"], ["item", ""]], template: function SuggestedActionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SuggestedActionsComponent_span_0_Template, 3, 10, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.actions);
    } }, dependencies: [ɵngcc3.NgForOf], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], SuggestedActionsComponent.prototype, "actions", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], SuggestedActionsComponent.prototype, "tabbable", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], SuggestedActionsComponent.prototype, "dispatch", void 0);
__decorate([
    HostBinding('class.k-quick-replies'),
    __metadata("design:type", Boolean)
], SuggestedActionsComponent.prototype, "defaultClass", void 0);
__decorate([
    ViewChildren('item'),
    __metadata("design:type", QueryList)
], SuggestedActionsComponent.prototype, "items", void 0);

const PUBLIC_DIRECTIVES = [
    ChatComponent,
    CustomMessagesComponent,
    AttachmentTemplateDirective,
    MessageTemplateDirective,
    HeroCardComponent
];
const PRIVATE_DIRECTIVES = [
    AttachmentComponent,
    FocusedStateDirective,
    LocalizedMessagesDirective,
    MessageAttachmentsComponent,
    MessageComponent,
    MessageListComponent,
    MessageTemplateDirective,
    ScrollAnchorDirective,
    SuggestedActionsComponent
];
/**
 * The [NgModule]({{ site.data.urls.angular['ngmodules'] }}) for the Chat component.
 *
 * @example
 * ```ts-no-run
 * import { NgModule } from '@angular/core';
 * import { Component } from '@angular/core';
 * import { BrowserModule } from '@angular/platform-browser';
 *
 * import { ChatModule } from '@progress/kendo-angular-conversational-ui';
 * import { AppComponent }   from './app.component';
 *
 * _@NgModule({
 *   imports:      [ BrowserModule, ChatModule ],
 *   declarations: [ AppComponent ],
 *   bootstrap:    [ AppComponent ]
 * })
 *
 * export class AppModule { }
 * ```
 */
let ChatModule = class ChatModule {
};
ChatModule.ɵfac = function ChatModule_Factory(t) { return new (t || ChatModule)(); };
ChatModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ChatModule });
ChatModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [ButtonModule,
        CommonModule,
        ResizeSensorModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoChatAttachmentTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoChatMessageTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChatComponent, [{
        type: Component,
        args: [{
                providers: [
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.chat'
                    }
                ],
                selector: 'kendo-chat',
                template: `
    <ng-container
      kendoChatLocalizedMessages
      i18n-messagePlaceholder="kendo.chat.messagePlaceholder|The placholder text of the message text input"
      messagePlaceholder="Type a message..."

      i18n-send="kendo.chat.send|The text for the Send button"
      send="Send..."
    >
    </ng-container>

    <div
      #messageList
      class="k-message-list k-avatars"
      aria-live="polite" role="log"
      kendoChatScrollAnchor
        #anchor="scrollAnchor"
        [(autoScroll)]="autoScroll"
    >
      <kendo-chat-message-list
        [messages]="messages"
        [messageTemplate]="messageTemplate"
        [attachmentTemplate]="attachmentTemplate"
        [user]="user"
        (executeAction)="dispatchAction($event)"
        (resize)="anchor.scrollToBottom()"
        (navigate)="this.autoScroll = false"
      >
      </kendo-chat-message-list>
    </div>

    <div class="k-message-box">
      <input
        #messageInput
        kendoChatFocusedState
        type="text"
        class="k-input"
        [placeholder]="textFor('messagePlaceholder')"
        (keydown)="inputKeydown($event)"
      >
      <button
        kendoButton
            look="flat"
        class="k-button-send"
        tabindex="-1"
        [attr.title]="textFor('send')"
        (click)="sendClick()"
      >${sendIcon}</button>
    </div>
  `
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: ɵngcc0.NgZone }]; }, { sendMessage: [{
            type: Output
        }], executeAction: [{
            type: Output
        }], className: [{
            type: HostBinding,
            args: ['class']
        }], dirAttr: [{
            type: HostBinding,
            args: ['attr.dir']
        }], messages: [{
            type: Input
        }], user: [{
            type: Input
        }], attachmentTemplate: [{
            type: ContentChild,
            args: [AttachmentTemplateDirective, { static: false }]
        }], messageTemplate: [{
            type: ContentChild,
            args: [MessageTemplateDirective, { static: false }]
        }], messageInput: [{
            type: ViewChild,
            args: ['messageInput', { static: true }]
        }], messageList: [{
            type: ViewChild,
            args: ['messageList', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-chat-attachment',
                template: `
    <ng-container *ngIf="template">
      <ng-container *ngTemplateOutlet="template.templateRef; context: context;">
      </ng-container>
    </ng-container>

    <div *ngIf="!template" class="k-card">
      <div class="k-card-body">
        <h5 class="k-card-title" *ngIf="attachment.title">
          {{ attachment.title }}
        </h5>
        <h6 class="k-card-subtitle" *ngIf="attachment.subtitle">
          {{ attachment.subtitle }}
        </h6>
        <img *ngIf="image" [attr.src]="attachment.content" />
        <ng-container *ngIf="unknown">
          {{ attachment.content }}
        </ng-container>
      </div>
    </div>
  `
            }]
    }], null, { attachment: [{
            type: Input
        }], template: [{
            type: Input
        }] }); })();

(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => CustomMessagesComponent_1)
                    }
                ],
                selector: 'kendo-chat-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FocusedStateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoChatFocusedState]'
            }]
    }], function () { return []; }, { focused: [{
            type: HostBinding,
            args: ['class.k-state-focused']
        }], onFocus: [{
            type: HostListener,
            args: ['focusin']
        }], onBlur: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeroCardComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-chat-hero-card',
                template: `
    <img class="k-card-image" [src]="imageUrl" *ngIf="imageUrl" />
    <div class="k-card-body">
      <h5 class="k-card-title" *ngIf="title">
        {{ title }}
      </h5>
      <h6 class="k-card-subtitle" *ngIf="subtitle">
        {{ subtitle }}
      </h6>
    </div>
    <div class="k-card-actions k-card-actions-vertical">
      <span class="k-card-action"
            *ngFor="let act of actions"
      >
        <button
          kendoButton look="flat"
          (click)="onClick(act)">
          {{ act.title }}
        </button>
      </span>
    </div>
  `
            }]
    }], function () { return []; }, { cssClass: [{
            type: HostBinding,
            args: ['class.k-card']
        }], executeAction: [{
            type: Output
        }], imageUrl: [{
            type: Input
        }], title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], actions: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizedMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => LocalizedMessagesDirective_1)
                    }
                ],
                selector: '[kendoChatLocalizedMessages]'
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageAttachmentsComponent, [{
        type: Component,
        args: [{
                providers: [{
                        provide: ChatItem,
                        useExisting: forwardRef(() => MessageAttachmentsComponent_1)
                    }],
                selector: 'kendo-chat-message-attachments',
                template: `
    <button
      *ngIf="carousel && scrollPosition > 0"
      (click)="scrollTo(-1)"
      class="k-button k-button-icon"
      tabindex="-1">
        <span class="k-icon k-i-arrow-chevron-left"></span>
    </button>
    <div #deck [class.k-card-deck]="carousel">
      <kendo-chat-attachment #item
        *ngFor="let att of attachments; index as index; first as first; last as last"
        [attachment]="att"
        [template]="template"
        [class.k-state-selected]="isSelected(index)"
        [class.k-state-focused]="isSelected(index)"
        [class.k-card-wrap]="true"
        [class.k-first]="first"
        [class.k-last]="last"
        [attr.tabindex]="tabbable && isSelected(index) ? '0' : '-1'"
        (click)="itemClick(index)"
        (keydown)="itemKeydown($event, att)"
      >
      </kendo-chat-attachment>
    </div>
    <button
      *ngIf="carousel && scrollPosition < 1"
      (click)="scrollTo(1)"
      class="k-button k-button-icon"
      tabindex="-1">
        <span class="k-icon k-i-arrow-chevron-right"></span>
    </button>
  `
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, { carousel: [{
            type: HostBinding,
            args: ['class.k-card-deck-scrollwrap']
        }], attachments: [{
            type: Input
        }], layout: [{
            type: Input
        }], tabbable: [{
            type: Input
        }], template: [{
            type: Input
        }], deck: [{
            type: ViewChild,
            args: ['deck', { read: ElementRef, static: true }]
        }], items: [{
            type: ViewChildren,
            args: ['item', { read: ElementRef }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-chat-message',
                providers: [{
                        provide: ChatItem,
                        useExisting: forwardRef(() => MessageComponent_1)
                    }],
                template: `
    <time
      [attr.aria-hidden]="!selected"
      class="k-message-time"
      *ngIf="message.timestamp"
    >
      {{ formatTimeStamp(message.timestamp) }}
    </time>

    <ng-container *ngIf="!message.typing; else typing">
      <div class="k-bubble" *ngIf="template">
        <ng-container
          *ngTemplateOutlet="template.templateRef; context: { $implicit: message };"
        >
        </ng-container>
      </div>

      <div class="k-bubble" *ngIf="!template && message.text">
        {{message.text}}
      </div>
    </ng-container>

    <span
      class="k-message-status"
      *ngIf="message.status"
    >
      {{ message.status }}
    </span>

    <ng-template #typing>
      <div class="k-bubble">
        <div class="k-typing-indicator">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </ng-template>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc4.IntlService }]; }, { cssClass: [{
            type: HostBinding,
            args: ['class.k-message']
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabIndex']
        }], message: [{
            type: Input
        }], tabbable: [{
            type: Input
        }], template: [{
            type: Input
        }], selected: [{
            type: HostBinding,
            args: ['class.k-state-selected']
        }, {
            type: HostBinding,
            args: ['class.k-state-focused']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageListComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-chat-message-list',
                template: `
    <ng-container *ngFor="let group of view; last as lastGroup; trackBy: trackGroup">
      <ng-container [ngSwitch]="group.type">
        <div
          *ngSwitchCase="'date-marker'"
          class="k-timestamp"
        >
          {{ formatTimeStamp(group.timestamp) }}
        </div>
        <div
          *ngSwitchCase="'message-group'"
          class="k-message-group"
          [class.k-alt]="isOwnMessage(group.messages[0])"
          [class.k-no-avatar]="!group.author.avatarUrl"
        >
          <img
            *ngIf="group.author.avatarUrl"
            [attr.src]="group.author.avatarUrl"
            class="k-avatar"
          />
          <p *ngIf="group.author.name" class="k-author">{{ group.author.name }}</p>
          <ng-container
              *ngFor="let msg of group.messages; first as firstMessage; last as lastMessage"
          >
            <img *ngIf="msg.user?.avatarUrl" [src]="msg.user?.avatarUrl" class="k-avatar">
            <kendo-chat-message #message
              [message]="msg"
              [tabbable]="lastGroup && lastMessage"
              [template]="messageTemplate"
              (click)="select(message)"
              (focus)="select(message)"
              [class.k-only]="group.messages.length === 1"
              [class.k-first]="group.messages.length > 1 && firstMessage"
              [class.k-last]="group.messages.length > 1 && lastMessage"
            >
            </kendo-chat-message>

            <kendo-chat-attachment
              *ngIf="msg.attachments && msg.attachments.length === 1"
              [attachment]="msg.attachments[0]"
              [template]="attachmentTemplate"
              >
            </kendo-chat-attachment>
          </ng-container>
        </div>

        <kendo-chat-message-attachments #attachments
          *ngSwitchCase="'attachment-group'"
          [attachments]="group.attachments"
          [layout]="group.attachmentLayout"
          [tabbable]="lastGroup"
          [template]="attachmentTemplate"
          (click)="select(attachments)"
          (focus)="select(attachments)"
        >
        </kendo-chat-message-attachments>

        <kendo-chat-suggested-actions #actions
          *ngSwitchCase="'action-group'"
          [actions]="group.actions"
          [tabbable]="lastGroup"
          (dispatch)="dispatchAction($event, last(group.messages))"
          (click)="select(actions)"
          (focus)="select(actions)"
        >
        </kendo-chat-suggested-actions>
      </ng-container>
    </ng-container>
    <kendo-resize-sensor (resize)="onResize()">
    </kendo-resize-sensor>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc4.IntlService }]; }, { executeAction: [{
            type: Output
        }], navigate: [{
            type: Output
        }], resize: [{
            type: Output
        }], cssClass: [{
            type: HostBinding,
            args: ['class.k-message-list-content']
        }], messages: [{
            type: Input
        }], onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], onBlur: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], attachmentTemplate: [{
            type: Input
        }], messageTemplate: [{
            type: Input
        }], user: [{
            type: Input
        }], items: [{
            type: ViewChildren,
            args: [ChatItem]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollAnchorDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoChatScrollAnchor]',
                exportAs: 'scrollAnchor'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.Renderer2 }]; }, { autoScroll: [{
            type: Input
        }], autoScrollChange: [{
            type: Output
        }], overflowAnchor: [{
            type: HostBinding,
            args: ['style.overflow-anchor']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuggestedActionsComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-chat-suggested-actions',
                providers: [{
                        provide: ChatItem,
                        useExisting: forwardRef(() => SuggestedActionsComponent_1)
                    }],
                template: `
    <span #item
      *ngFor="let action of actions; index as index; first as first; last as last"
      class="k-quick-reply"
      [class.k-state-selected]="isSelected(index)"
      [class.k-state-focused]="isSelected(index)"
      [class.k-first]="first"
      [class.k-last]="last"
      [attr.tabindex]="tabbable && selectedIndex === index ? '0' : '-1'"
      (click)="actionClick(action)"
      (keydown)="actionKeydown($event, action)"
    >
      {{ action.title || action.value }}
    </span>
  `
            }]
    }], null, { dispatch: [{
            type: Output
        }], defaultClass: [{
            type: HostBinding,
            args: ['class.k-quick-replies']
        }], actions: [{
            type: Input
        }], tabbable: [{
            type: Input
        }], items: [{
            type: ViewChildren,
            args: ['item']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChatModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ...PUBLIC_DIRECTIVES,
                    ...PRIVATE_DIRECTIVES
                ],
                exports: [PUBLIC_DIRECTIVES],
                imports: [
                    ButtonModule,
                    CommonModule,
                    ResizeSensorModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ChatModule, { declarations: function () { return [ChatComponent, CustomMessagesComponent, AttachmentTemplateDirective, MessageTemplateDirective, HeroCardComponent, AttachmentComponent, FocusedStateDirective, LocalizedMessagesDirective, MessageAttachmentsComponent, MessageComponent, MessageListComponent, MessageTemplateDirective, ScrollAnchorDirective, SuggestedActionsComponent]; }, imports: function () { return [ButtonModule,
        CommonModule,
        ResizeSensorModule]; }, exports: function () { return [ChatComponent, CustomMessagesComponent, AttachmentTemplateDirective, MessageTemplateDirective, HeroCardComponent]; } }); })();


/**
 * Generated bundle index. Do not edit.
 */

export { PreventableEvent, HeroCardComponent, AttachmentComponent, ChatItem, CustomMessagesComponent, LocalizedMessagesDirective, Messages, MessageAttachmentsComponent, MessageListComponent, MessageComponent, SuggestedActionsComponent, FocusedStateDirective, ScrollAnchorDirective, ChatComponent, AttachmentTemplateDirective, MessageTemplateDirective, ChatModule, ExecuteActionEvent, SendMessageEvent };

